/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

import {Destroyable} from '../../../destroyable.component';
import {CliEmpAttributes} from '../../../models/models.interfaces';
import {AnyData} from '../../api';
import {ContractStatus} from '../../employees/contract/contract.interfaces';
import {Contract} from '../../employees/employees.model';
import {getInitials} from '../../utils/strings';


@Component({
  selector: 'gp-teams-list-employee',
  templateUrl: './teams-list-employee.component.html',
  styleUrls: ['./teams-list-employee.component.scss']
})
export class TeamsListEmployeeComponent extends Destroyable implements OnInit {

  @Input()
  employee: any;

  @Input()
  isSelected: boolean = false;

  @Input()
  public isIframe: boolean = false;

  @Input()
  public displayIncomplete: boolean = false;

  @Output()
  menuClicked = new EventEmitter<{ employee: CliEmpAttributes, event: MouseEvent }>();

  @Output()
  employeeClicked = new EventEmitter<{ employee: CliEmpAttributes, event: MouseEvent }>();

  public isMenuClickObserved = false;
  public isEmployeeClickObserved = false;
  public cliRegNickName: string;
  public contractDates: string;

  constructor() {
    super();
  }

  public ngOnInit(): void {
    this.isMenuClickObserved = this.menuClicked.observers.length > 0;
    this.isEmployeeClickObserved = this.employeeClicked.observers.length > 0;
    this.cliRegNickName = `${this.employee.empContracts[0].cliRegNickName}`;
    this.contractDates = `${this.employee.empContracts[0].begindate} - ${this.employee.empContracts[0].enddate}`;
  }

  public getPicture(employee: AnyData) {
    const link = employee?.links?.find(lnk => lnk.rel === 'photo');
    return link ? link.href : undefined;
  }

  public menuClick(employee: CliEmpAttributes, event: MouseEvent) {
    event.stopPropagation();
    this.menuClicked.emit({employee, event});
  }

  public employeeClick(employee: CliEmpAttributes, event: MouseEvent) {
    this.employeeClicked.emit({employee, event});
  }

  public isInactive(contracts: Contract): boolean {
    if (contracts?.length) {
      return contracts[0].status === ContractStatus.INACTIVE;
    }
    return false;
  }

  public getInitials(employee: CliEmpAttributes): string {
    return getInitials(employee?.firstName, employee?.lastName);
  }
}
